var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.filteredList.length)?_c('b-list-group',_vm._l((_vm.filteredList),function(item){return _c('side-bar-item',{key:item.title,attrs:{"item":item},on:{"dashboardSelected":_vm.onLinkClick}})}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }